var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-pwd-succ"},[_c('i',{staticClass:"iconfont iconchenggong"}),_c('h2',[_vm._v("修改密码成功")]),_c('p',[_vm._v("修改密码成功，输入新密码登录系统")]),_c('a',{on:{"click":_vm.toSetPwd}},[_vm._v("确认")])])
}
var staticRenderFns = []

export { render, staticRenderFns }